export default __webpack_public_path__ + "989cbb3ffda13bd3109a74fa9aa8f87c.png";